<template>    
     <BaseModal
        :id="'static'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                />
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import FormDynamic      from    '@/components/FormDynamic.vue'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'


export default {

    name:   'FormModal',
    props: [
        "title",
        "rest_api",
        "parent_id",
        "notyf",
        "array_options",
        "breadcrumb",
  ],

    components:{
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            form_data:    FormResources.form_data,
            form_format:  FormResources.form_format,
            form_backup:  {...FormResources.form_data},
        }
    },

    watch: {
        parent_id(val)
        {
            this.form_data.daily_assignment_id = val
            this.form_backup.daily_assignment_id = val
        },

        "form_data.room_type_id"(val){

        if(val){
          let floor_name = this.array_options['room_type_id'].find((data) => data.id === val)
          this.form_data.floor_id = floor_name.floor_id
        }

      },
      
      async 'form_data.building_id'(val){

        if(val){

          let http_request = {
            request_id:     val,
            rooms_request:  false,
            levels_request: true,
            areas_request:  false,
          }

          const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`);

          if(response.status) {
             if(response.data.levels.length){

              this.array_options['level_id']  = response.data.levels
              this.array_options['room_id']   = response.data.rooms

            }else{

              this.array_options['level_id']  = []
              this.array_options['area_id']   = []
              this.array_options['room_id']   = []
              this.form_data.level_id         = ''
              this.form_data.area_id          = ''
              this.form_data.room_id          = []

            }
          } else {
             this.error_handling(response)
          }

        }else{
          this.array_options['level_id']  = []
          this.array_options['area_id']   = []
          this.array_options['room_id']   = []
        }

      },

      async 'form_data.level_id'(val){

        if(val){

          let level_room = this.array_options['level_id'].find(prop => prop.id === val)

          level_room != '' ? 
            this.array_options['room_id'] = level_room.rooms 
            : 
            this.array_options['room_id'] = []

          let http_request = {
            request_id:     val,
            rooms_request:  false,
            levels_request: false,
            areas_request:  true,
          }

          const response = await this.get(`${this.rest_api}/${JSON.stringify(http_request)}`)
          if(response.status) {
            if(response.data.areas.length){
              this.array_options['area_id'] = response.data.areas
              this.form_data.area_id        = ''
            }else{
              this.array_options['area_id'] = []
              this.form_data.area_id        = ''
            }
          } else {
            this.error_handling(response)
          }

        }else{

          this.array_options['area_id'] = []
          this.array_options['room_id'] = []
          this.form_data.area_id        = ''
          this.form_data.room_id        = ''

        }

      },

      'form_data.area_id'(val){
        
        if(val){

          let area_room = this.array_options['area_id'].find(prop => prop.id === val)

          area_room != undefined ? 
            this.array_options['room_id'] = area_room.rooms 
            : 
            this.array_options['room_id'] = []

        }

      },

    } ,

    methods:{},

    mounted(){

    }
    
}
</script>